
export default {

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    computed: {
        jsonModel() {
            const defaults = {
                tag: 'event',
                bgImage: null,
                redirect: null,
                confirm: {
                    heading: null,
                    description: null,
                    inviteLinkAction: null,
                },
                form: {
                    heading: null,
                    description: null,
                    fields: [],
                    addEntryAction: null,
                    submitAction: null,
                },
                eventDetails: {
                    text: null,
                    dates: null,
                    details: null,
                    location: null,
                },
                extra: {},
            }
            return Object.assign({}, defaults, this.model)
        },

        googleCalendarEventLink() {
            if (this.jsonModel.eventDetails === null) return null
            if (!this.jsonModel.eventDetails.text || !this.jsonModel.eventDetails.dates || !this.jsonModel.eventDetails.details || !this.jsonModel.eventDetails.location) return null
            const text = encodeURIComponent(this.jsonModel.eventDetails?.text)
            const dates = encodeURIComponent(this.jsonModel.eventDetails?.dates)
            const details = encodeURIComponent(this.jsonModel.eventDetails?.details)
            const location = encodeURIComponent(this.jsonModel.eventDetails?.location)
            return `https://calendar.google.com/calendar/u/0/r/eventedit?text=${text}&dates=${dates}&details=${details}&location=${location}&sf=true&output=xml`
        },

    },

    data() {
        return {
            isLoading: false,
            isSent: false,
            formModel: {},
            entries: [],
        }
    },

    methods: {

        buildModel() {
            if (this.jsonModel.form && this.jsonModel.form.fields) {
                this.jsonModel.form.fields.forEach(group => {
                    if (group && group instanceof Array)
                        group.forEach(field => {
                            if (field.key) {
                                this.$set(this.formModel, field.key, field.default || '')
                            }
                        })
                })
            }
        },

        submit() {
            this.isLoading = true
            this.$axios.$post('/api/v1/event-submit', { tag: this.jsonModel.tag, entries: this.entries }).then((res) => {
                this.isSent = true
                if (this.jsonModel.redirect) this.$router.push({ path: this.jsonModel.redirect })
            }).catch(() => {
                this.isLoading = false
            })
        },

        addEntry() {
            this.entries.push(JSON.parse(JSON.stringify(this.formModel)))
        },
    },

    mounted() {
        this.buildModel()
        this.addEntry()
    },

}
